// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from '../models/environment';

export const baseEnvironment: Environment = {
    production: false,
    exceptionlessUrl: '',
    exceptionlessKey: '',
    debugDrawer: 'true',
    site: 'quote',
    cmsUrl: '',
    cmsAppName: 'sales',
    cmsClientId: '',
    cmsClientSecret: '',
    cmsScope: 'squidex-api',
    cmsAssetUrl: '/api/assets/con-fusion',
    apiUrl: '',
    turnstileSiteKey: '',
    kongUrl: '',
    kongClientId: '',
    kongClientSecret: '',
    kongScope: '',
    cmsEnvId: 'dev',
    kongAuthToken: '',
    headerWhiteList: [],
    staticPageUrl: 'landing/get-started',
    cmsUseTransferService: true,
    globalErrorMessage:
        'Oops!! something went wrong! We apologise for the inconvenience. Please try again later.',
    globalErrorDialogTitle: 'Error',
    globalErrorRetryMessage:
        'Looks like your request is taking longer than usual to load. Please retry or request a callback',
    globalErrorRetryTitle: 'This is taking a while...',
    globalErrorCallbackText: 'Request callback',
    globalErrorRetryText: 'Retry',
    retryLimit: 3,
    debugId: 'Con-Fusion',
    ssrCacheMinutes: 0,
    appInsightsInstrumentationKey: '',
    enableTrackingScripts: 'false',
    enableExpressServerGzip: 'false',
    enableDynamicContactFilter: 'true',
    defaultBaseRoute: '',
    enableSsrAbTesting: 'false',
    webtrendsKeyToken: '',
    webtrendsAccountId: '',
    webtrendsMode: 'staging',
    checkIntervalMinutes: 30,
};
